import React, { CSSProperties } from 'react';
import { animated } from 'react-spring';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../../../types';

interface ICarouselItemProps extends IBaseComponentProps<HTMLDivElement> {
    children?: React.ReactChild | Array<React.ReactChild>;
    index: number;
    itemId: React.Key;
    maxHeight: string;
    style: CSSProperties;
    onClick(itemId: React.Key): void;
}

function CarouselItemWrapperBase(props: ICarouselItemProps) {
    const { className, elementRef, children, itemId, style, onClick } = props;
    const _onClick = React.useCallback(() => { onClick(itemId); }, [itemId, onClick]);
    return <animated.div className={className} style={style} ref={elementRef} onClick={_onClick}>{children}</animated.div>;
}

export const CarouselItemWrapper = styled(CarouselItemWrapperBase).attrs({
    className: String('ap-carousel-item')
})`
    display: inherit;
    position: absolute;
    height: 100%;
    width: 100%;
    transform-origin: 50% 0%;
    max-height: ${({ maxHeight }) => maxHeight};
    z-index: ${({ index }) => index};
`;
